<div class="w-100">
    <div class="mb-3">
        <h3 class="text-heading-3 text-dark">Store Analytics</h3>
    </div>

    <!-- stocks count -->
    <div class="d-flex flex-row flex-wrap gap-3 mb-3">
        <div *ngFor="let stock of stocks" class="app-border-grey p-3 flex-grow-1">
            <div class="d-flex gap-2 align-items-center mb-1">
                <img class="icon-sm" [src]="stock.imgUrl" alt="" srcset="">
                <p class="text-para text-dark text-capitalize">{{ stock.name }}</p>
            </div>
            <div class="text-heading-3 text-dark">
                {{ stock.count }}
            </div>
        </div>
    </div>

    <div class="d-flex gap-3 mb-3"> 
        <div class="app-border-grey w-50 p-3">
            <h4 class="text-heading-4 text-dark mb-4">Consumption Summary</h4>
            <div class="d-flex align-items-center justify-content-center analytics-group">
                <p [ngClass]="warningMessageConsumedByWeek !== '' ? '' : 'd-none'" class="text-para text-dark">{{ warningMessageConsumedByWeek }}</p>
                <canvas [ngClass]="warningMessageConsumedByWeek === '' ? '' : 'd-none'" id="consumed-week"></canvas>
            </div>
        </div> 
        <div class="app-border-grey w-50 p-3">
            <div class="d-flex align-items-center justify-content-between mb-4"> 
                <h4 class="text-heading-4 text-dark">Top 5 Stores</h4>
                <div class="d-flex align-items-center tab-group">
                    <div class="text-heading-6 text-dark px-2 py-1 tab active" (click)="switchStoresChart($event, 'consumed')">Consumed</div>
                    <div class="text-heading-6 text-dark px-2 py-1 tab" (click)="switchStoresChart($event, 'missing')">Missing</div>
                </div>
            </div>
            <div class="d-flex align-items-center justify-content-center analytics-group">
                <p [ngClass]="warningMessageConsumedByStores !== '' ? '' : 'd-none'" class="text-para text-dark">{{ warningMessageConsumedByStores }}</p>
                <!-- <canvas [ngClass]="warningMessageConsumedByStores === '' ? '' : 'd-none'" id="consumed-stores"></canvas> -->
                <div [ngClass]="warningMessageConsumedByStores === '' ? '' : 'd-none'" class="w-100 d-flex align-items-center gap-4">
                    <div class="w-50">
                        <canvas id="consumed-stores"></canvas>
                    </div>
                    <div class="flex-grow-1">
                        <ng-template [ngIf]="donutLegendStoreType.length !== 0">
                            <div *ngFor="let legend of donutLegendStoreType" class="chart-legend">
                                <div class="circle-wrapper">
                                    <div class="circle" [style]="'background-color: '+legend.backgroundColor+';'"></div>
                                </div>
                                <div class="label-wrapper">
                                    <div class="text-para text-dark">{{ legend.label }}</div>
                                </div>
                                <div class="count-wrapper">
                                    <div class="text-heading-6 text-dark">{{ legend.count }}</div>
                                </div>
                            </div>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="d-flex gap-3 mb-3">
        <div class="app-border-grey w-50 p-3">
            <div class="d-flex align-items-center justify-content-between mb-4"> 
                <h4 class="text-heading-4 text-dark">Most Consumed Product Type </h4>
                <div class="d-flex align-items-center tab-group">
                    <div class="text-heading-6 text-dark px-2 py-1 tab active" (click)="switchProductsChart($event, 'body_parts')">Body part</div>
                    <div class="text-heading-6 text-dark px-2 py-1 tab" (click)="switchProductsChart($event, 'implants')">Implant</div>
                </div>
            </div>
            <div class="d-flex align-items-center justify-content-center analytics-group">
                <p [ngClass]="warningMessageConsumedByProducts !== '' ? '' : 'd-none'" class="text-para text-dark">{{ warningMessageConsumedByProducts }}</p>
                <div [ngClass]="warningMessageConsumedByProducts === '' ? '' : 'd-none'" class="w-100 d-flex align-items-center gap-4">
                    <div class="w-50">
                        <canvas id="consumed-product-types"></canvas>
                    </div>
                    <div class="flex-grow-1">
                        <ng-template [ngIf]="donutLegendProductType.length !== 0">
                            <div *ngFor="let legend of donutLegendProductType" class="chart-legend">
                                <div class="circle-wrapper">
                                    <div class="circle" [style]="'background-color: '+legend.backgroundColor+';'"></div>
                                </div>
                                <div class="label-wrapper">
                                    <div class="text-para text-dark">{{ legend.label }}</div>
                                </div>
                                <div class="count-wrapper">
                                    <div class="text-heading-6 text-dark">{{ legend.count }}</div>
                                </div>
                            </div>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
        <div class="app-border-grey w-50 p-3">
            <h4 class="text-heading-4 text-dark mb-4">Expired Summary</h4>
            <div [ngClass]="warningMessageExpired !== '' ? '' : 'd-none'" class="d-flex align-items-center justify-content-center analytics-group">
                <p class="text-para text-dark">{{ warningMessageExpired }}</p>
            </div>
            <ul [ngClass]="warningMessageExpired === '' ? '' : 'd-none'" class="d-flex flex-column p-1 list-group analytics-group">
                <li 
                    class="d-flex align-items-center justify-content-between px-3 py-2 app-border-grey"
                    *ngFor="let item of expiredStocks"
                >
                    <div>
                        <p class="text-para text-dark">{{ item.store_name }}</p>
                    </div>
                    <div class="d-flex align-items-center gap-1">
                        <img class="icon-sm" src="../../../assets/images/cabinet/expired.svg" alt="" srcset="">
                        <p>{{ item.count }}</p>
                    </div>
                </li>
            </ul>
        </div>
    </div>

    <div class="d-flex gap-3">
        <div class="app-border-grey w-50 p-3">
            <div class="d-flex align-items-center justify-content-between mb-4"> 
                <h4 class="text-heading-4 text-dark">Stores</h4>
            </div>
            <div class="position-relative align-items-center justify-content-center analytics-group">
                <div [ngClass]="warningMessageGeoChart !== '' ? '' : 'd-none'" class="d-flex align-items-center justify-content-center analytics-group">
                    <p class="text-para text-dark">{{ warningMessageGeoChart }}</p>
                </div>
                <div [ngClass]="warningMessageGeoChart === '' ? '' : 'd-none'" id="geo-chart" style="width: 100%; height: 100%"></div>
            </div>
        </div>
        <div class="app-border-grey w-50 p-3">
            <div class="mb-4 d-flex align-items-center justify-content-between">
                <h4 class="text-heading-4 text-dark">About to Expiry</h4>
                <a href="" routerLink="/analytics" class="text-link text-primary text-decoration-underline">View all</a>
            </div>
            <div [ngClass]="warningMessageExpiring !== '' ? '' : 'd-none'" class="d-flex align-items-center justify-content-center analytics-group">
                <p class="text-para text-dark">{{ warningMessageExpiring }}</p>
            </div>
            <ul [ngClass]="warningMessageExpiring === '' ? '' : 'd-none'" class="d-flex flex-column p-1 list-group analytics-group">
                <li 
                    class="d-flex align-items-center justify-content-between px-3 py-2 app-border-grey"
                    *ngFor="let item of expiringStocks"
                >
                    <div class="d-flex align-items-center gap-2">
                        <img class="icon-md" src="../../../assets/images/cabinet/product.png" alt="" srcset="">
                        <div>
                            <p class="text-heading-5 text-dark">{{item.product_name}}</p>
                            <p class="text-para text-grey-100">{{item.store_name}} | {{item.cabinet_name? item.cabinet_name : '-'}}</p>
                        </div>
                    </div>
                    <div class="d-flex align-items-center gap-1">
                        <img class="icon-sm" src="../../../assets/images/cabinet/expiring.svg" alt="" srcset="">
                        <p>{{ item.expiry_date }}</p>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</div>
